<div id="jobs-add-files" class="step-page">
    <div class="step-title">
        <div class="row-wrap">
            <div class="row-left">
                <div>
                    File Selection and Preview
                </div>
                <!-- <div style="margin-left: 50px;">
                    <div style="display: inline-block; cursor: pointer;" (click)="filesInput.click()">
                        <i class="glyphicons glyphicons-cloud-upload"></i>
                        <span style=" font-size: 13px; vertical-align: baseline;">Add Files</span>
                    </div>
                    <input #filesInput 
                        type="file" 
                        id="file-uploader"
                        name="file-uploader" 
                        (change)="loadFiles(filesInput.files)"
                        multiple hidden>
                </div> -->
            </div>			
            <div class="row-right btn-groups">
                <button class="button-general" [disabled]="!(layers | async).length || fileForm.invalid" (click)="goNext()">Next</button>
            </div>		
                    
        </div>
    </div>
    <div class="step-content">
        <div class="file-selection">
            <form #fileForm="ngForm" appFileDropZone (onDropFiles)="onDropFiles($event)">
                    <!-- <div class="watermark-float">
                        <div *ngIf="!(layers | async).length" class="watermark-float-content">
                            Drop Files Here To Upload
                        </div>
                    </div> -->
                    <div *ngIf="!(layers | async).length" class="upload-select-container">
                        <div class="upload-select-files" style="display: inline-block; cursor: pointer;" (click)="filesInput.click()">
                            <i class="glyphicons glyphicons-cloud-upload"></i>
                            <span style=" font-size: 13px; vertical-align: baseline;">Click here to upload zip files</span>
                        </div>
                        <input #filesInput 
                            type="file" 
                            id="file-uploader"
                            name="file-uploader" 
                            (change)="loadFiles(filesInput.files)"
                            multiple hidden>
                    </div>
                    <table id="source-table">
                        <div class="table-header">
                            <div class="table-row">
                                <div class="table-th">&#8203;</div>
                                <div class="table-th">Data File</div>
                                <div class="table-th">Record Count</div>
                                <div class="table-th">Dataset Category</div>
                            </div>							
                        </div>
                        <div class="table-body">
                            <div class="table-row" 
                                *ngFor="let layer of layers | async; trackBy: trackByFn; let idx = index;" 
                                 
                                [ngClass]="{'selected-name': layer===selectedLayer}"
                                [hidden]="">
                                <div class="table-td operations">
                                    <div>
                                        <i class="glyphicons glyphicons-remove" (click)="removeLayer(idx)"></i>	
                                    </div>
                                    <!-- <div class="glyphicons glyphicons-search" (click)="clickLayer(idx)" title="Preview"></div> -->
                                </div>
                                <div class="table-td layer-name" (click)="clickLayer(idx)">
                                    <div>
                                        {{layer.name}}				
                                    </div>
                                </div>
                                <div class="table-td">
                                    <div>
                                        {{layer.content.numOfRecords}}
                                    </div>
                                </div>
                                <div class="table-td">
                                    <div>
                                        <select 
                                            name="layer-category-{{idx}}" 
                                            [(ngModel)]="layer.category" 
                                            (change)="changeCate(idx, layer.category)"
                                            required>
                                            <option *ngFor="let cate of categoryList" [ngValue]="cate.name" [hidden]="layer.cateGeomType&&layer.cateGeomType!==cate.geomType">{{cate.definedBy}} - {{cate.code}}</option>
                                        </select>
                                    </div>
                                </div>		
                            </div>								
                        </div>	
                    </table>
                <!-- <table id="source-table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Data File</th>
                            <th>
                                Dataset Category
                            </th>
                        </tr>							
                    </thead>
                    <tbody>
                        <tr *ngFor="let layer of layers | async; let idx = index;" 
                            (click)="clickLayer(idx)" 
                            [hidden]="">
                            <td>
                                <i class="glyphicons glyphicons-remove" (click)="removeLayer(idx)"></i>			
                            </td>
                            <td class="layer-name">
                                <div>
                                    {{layer.name}}				
                                </div>
                            </td>
                            <td>
                                <div>
                                    <select name="layer-category-{{idx}}" [(ngModel)]="layer.category" required>
                                        <option *ngFor="let cate of categoryList" [ngValue]="cate.name">{{cate.name}}</option>
                                    </select>
                                </div>
                            </td>		
                        </tr>								
                    </tbody>	
                </table> -->
            </form>
        </div>
        <div *ngIf="previewRows.length" class="file-preview">
            <!-- <div class="watermark"></div> -->
            <app-common-datagrid
                class="material"
                [columnMode]="'force'"					
                [rows]="previewRows"
                [columns]="previewColumns"
                [selectionType]="'single'"
                [hidePaging]="true"
            ></app-common-datagrid>
        </div>
    </div>
</div>
